// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { getWorkshopContentsData } from '../../../apis/workshop';
import getWorkshopContentsDataActions from '../../actionCreators/workshop/getWorkshopContentsDataActions';
import { RootAction } from '../../rootActionCreator';

const outputActions = {
  success: getWorkshopContentsDataActions.success,
  failure: getWorkshopContentsDataActions.failure
};

type RequestActionTypes = ActionType<
  typeof getWorkshopContentsDataActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

const getWorkshopContentsDataEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(getWorkshopContentsDataActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id } = action.payload;
      // send api promise
      return getWorkshopContentsData(id)
        .then(response => {
          const {
            chapters,
            progress,
          } = response.data;
          // handle success case here
          return getWorkshopContentsDataActions.success({
            id,
            chapters,
            progress
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          console.log(error)
          return getWorkshopContentsDataActions.failure({ error });
        });
    })
  );
};

export { getWorkshopContentsDataEpic as default};
